export function isEmailAllowedInStaging(email: string): boolean {
  const isStaging = process.env.MODE === 'staging'

  if (!isStaging) {
    return true
  }

  const allowedDomains = [
    '@zamply',
    '@zamply.com',
    '@zamply.com.br',
    '@incibrasil',
    '@incibrasil.com',
    '@incibrasil.com.br',
  ]

  const emailLower = email.toLowerCase().trim()

  return allowedDomains.some(domain => emailLower.endsWith(domain))
}

export function getStagingEmailErrorMessage(): string {
  return 'Cadastro não permitido no ambiente de TESTES'
}
